import {styled, Stack} from '@mui/material'

export const ContentContainer = styled(Stack)(() => ({
  height: '100vh',
  width: '100vw',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const imageStyle = {
  height: '5rem',
  marginBottom: '10rem',
  cursor: 'pointer',
}
